// Anita Week 10 / Day 1 — Light of Choice: Money, Value and Goal.
// Verbatim from FINAL Week 10 Part A (Final Quest) source-of-truth package.
// Staged on disk; Week 10 remains a locked placeholder until Days 4–5 are
// authored. Night Runner gate is NOT changed yet.

const day1 = {
  id: 'day-1',
  studentId: 'anita',
  weekId: 'week-10',
  dayId: 'day-1',
  status: 'active',
  title: 'Огонёк выбора: деньги, ценность и цель / Light of Choice: Money, Value and Goal',
  shortTitle: 'Огонёк выбора / Light of Choice',
  theme: 'Анита повторяет деньги, выбор, пользу, цель накопления и учебный риск через короткий квест. / Anita reviews money, choice, usefulness, saving goal and learning risk through a short quest.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  readingLevel: 'grade-2',
  courseLayers: ['reading', 'math', 'quest-review', 'money-choice', 'memory-cards', 'creative', 'speech'],
  questMeta: { lightId: 'choice-light', lightNameRu: 'Огонёк выбора', lightNameEn: 'Light of Choice', questNode: 1, passportStamp: 'выбор' },
  nimnyIntro:
    'Нимни открывает первую дверь финального квеста. За дверью светится Огонёк выбора. Чтобы получить его, Анита вспоминает: деньги помогают выбирать, но настоящая ценность появляется из пользы, цели и честного решения. / Nimny opens the first door of the final quest. Behind the door shines the Light of Choice. To collect it, Anita remembers: money helps people choose, but real value comes from usefulness, goals and honest decisions.',
  goals: [
    'Повторить деньги, цену, пользу и цель. / Review money, price, usefulness and goal.',
    'Отличать «нужно», «хочу», «полезно» и «цель». / Sort need, want, useful and goal.',
    'Решать квест-задачи с нимами, остатком, умножением и делением. / Solve quest math with nims, remaining amount, multiplication and division.',
    'Повторить идею «не всё в одну корзину». / Review "not everything in one basket."',
    'Поставить штамп Огонька выбора в quest passport. / Add the Light of Choice stamp to the quest passport.',
    'Объяснить родителю главный вывод. / Explain the main idea to parent.'
  ],
  vocabulary: [
    { term: 'выбор / choice', definition: 'когда нужно решить, что взять или сделать. / when you need to decide what to take or do.' },
    { term: 'цена / price', definition: 'сколько нужно отдать в учебной симуляции. / how many nims you give in the learning simulation.' },
    { term: 'польза / usefulness', definition: 'как вещь или идея помогает. / how a thing or idea helps.' },
    { term: 'цель / goal', definition: 'то, к чему человек идёт. / what a person is heading toward.' },
    { term: 'копилка / savings jar', definition: 'место для сохранения нимов. / a place to save nims.' },
    { term: 'остаток / remaining amount', definition: 'сколько осталось после выбора. / how much is left after a choice.' },
    { term: 'риск / risk', definition: 'когда результат не гарантирован. / when the result is not guaranteed.' },
    { term: 'корзина / basket', definition: 'место, куда кладут часть ресурса. / where a part of the resource is placed.' },
    { term: 'огонёк / light', definition: 'знак знания в финальном квесте. / a sign of knowledge in the final quest.' },
    { term: 'вывод / conclusion', definition: 'что я поняла. / what I have understood.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова огонька выбора / Choice Light Words',
      prompt: 'Прочитай по-русски:\n\nвыбор\nцена\nпольза\nцель\nкопилка\nостаток\nриск\nкорзина\nогонёк\nвывод',
      ruPrimaryText: 'Прочитай 10 русских слов огонька выбора.',
      enHelpText: 'Read the Russian quest words first. English is only for help.',
      answer: 'Attempted Russian reading.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Фразы огонька / Light Sentences',
      prompt: 'Прочитай по-русски:\n\nДеньги помогают выбирать.\nПольза создаёт ценность.\nЯ могу копить на цель.\nРиск значит: результат не гарантирован.\nЯ не кладу всё в одну корзину.',
      ruPrimaryText: 'Прочитай 5 фраз огонька выбора.',
      enHelpText: 'Money helps people choose. Usefulness creates value. I can save for a goal. Risk means the result is not guaranteed. I do not put everything in one basket.',
      answer: 'Attempted Russian reading.' },
    { id: 'choice-card-sort', type: 'classify', title: 'Задание 3 — Карточки выбора / Choice Cards',
      prompt: 'Разложи 12 карточек по категориям.\n\nКатегории:\nНужно\nХочу\nПолезно\nЦель\n\nКарточки:\n1. вода\n2. тёплая куртка зимой\n3. наклейка\n4. книга для чтения\n5. маленькая игрушка\n6. копить на большую цель\n7. рюкзак для уроков\n8. конфета\n9. карандаш для рисования\n10. сохранить часть нимов\n11. реклама говорит «бери сразу»\n12. полезная идея, которая помогает человеку',
      ruPrimaryText: 'Разложи 12 карточек: нужно / хочу / полезно / цель.',
      enHelpText: 'Sort 12 cards: need / want / useful / goal.',
      categories: [
        { id: 'need', label: 'Нужно / Need' },
        { id: 'want', label: 'Хочу / Want' },
        { id: 'useful', label: 'Полезно / Useful' },
        { id: 'goal', label: 'Цель / Goal' }
      ],
      items: [
        { id: 'c1', label: '1. вода', category: 'need' },
        { id: 'c2', label: '2. тёплая куртка зимой', category: 'need' },
        { id: 'c3', label: '3. наклейка', category: 'want' },
        { id: 'c4', label: '4. книга для чтения', category: 'useful' },
        { id: 'c5', label: '5. маленькая игрушка', category: 'want' },
        { id: 'c6', label: '6. копить на большую цель', category: 'goal' },
        { id: 'c7', label: '7. рюкзак для уроков', category: 'useful' },
        { id: 'c8', label: '8. конфета', category: 'want' },
        { id: 'c9', label: '9. карандаш для рисования', category: 'useful' },
        { id: 'c10', label: '10. сохранить часть нимов', category: 'goal' },
        { id: 'c11', label: '11. реклама говорит «бери сразу»', category: 'want' },
        { id: 'c12', label: '12. полезная идея, которая помогает человеку', category: 'useful' }
      ],
      answer: 'Нужно: 1, 2. Хочу: 3, 5, 8, 11. Полезно: 4, 7, 9, 12. Цель: 6, 10.' },
    { id: 'math-choice-gate', type: 'text', title: 'Задание 4 — Ворота выбора / Choice Gate Math',
      prompt: 'У Аниты в квесте 72 нима.\n\nПредметы для миссии:\nкарта — 18 нимов\nкомпас — 14 нимов\nфонарик — 22 нима\nтетрадь — 9 нимов\n\nОтветь:\n1. Сколько стоит карта + компас?\n2. Сколько останется после карты + компаса?\n3. Сколько стоит фонарик + тетрадь?\n4. Можно ли взять карту, компас и тетрадь и оставить хотя бы 25 нимов?',
      ruPrimaryText: 'Реши 4 задачи про 72 нима и предметы миссии.',
      enHelpText: 'Solve 4 quest-gate math problems.',
      answer: '1) 18 + 14 = 32. 2) 72 − 32 = 40. 3) 22 + 9 = 31. 4) 18 + 14 + 9 = 41; 72 − 41 = 31. Да, можно оставить 31, это больше 25.' },
    { id: 'math-saving-light', type: 'text', title: 'Задание 5 — Путь к цели / Saving Path',
      prompt: 'Цель квеста — 96 нимов.\nУ Аниты уже есть 36 нимов.\n\nОна проходит 4 маленькие миссии.\nКаждая миссия добавляет 8 нимов в учебной симуляции.\n\nОтветь:\n1. Сколько нимов добавят 4 миссии?\n2. Сколько будет всего?\n3. Сколько ещё нужно до 96?\n4. Если осталось 28 нимов, можно ли разделить их поровну на 4 маленьких шага?',
      ruPrimaryText: 'Реши 4 задачи про путь к цели 96 нимов.',
      enHelpText: 'Solve 4 saving-path problems.',
      answer: '1) 4 × 8 = 32. 2) 36 + 32 = 68. 3) 96 − 68 = 28. 4) 28 ÷ 4 = 7. Да, по 7 нимов на шаг.' },
    { id: 'math-basket-risk', type: 'text', title: 'Задание 6 — Корзины риска / Risk Baskets',
      prompt: 'У Нимни 24 ним-семени.\nОна делит их поровну в 3 корзины.\n\nПотом:\nКорзина 1 выросла на 2.\nКорзина 2 выросла на 0.\nКорзина 3 выросла на 4.\n\nОтветь:\n1. Сколько семян в каждой корзине сначала?\n2. Сколько стало в Корзине 1?\n3. Сколько стало в Корзине 2?\n4. Сколько стало в Корзине 3?\n5. Сколько всего теперь?',
      ruPrimaryText: 'Реши 5 задач про 24 ним-семени и 3 корзины.',
      enHelpText: 'Solve 5 risk-basket problems.',
      answer: '1) 24 ÷ 3 = 8. 2) 8 + 2 = 10. 3) 8 + 0 = 8. 4) 8 + 4 = 12. 5) 10 + 8 + 12 = 30.' },
    { id: 'quest-memory-graph', type: 'text', title: 'Задание 7 — Мини-график выбора / Mini Choice Graph',
      prompt: 'Нимни записала карточки выбора:\n\nнужно — 4\nхочу — 5\nполезно — 6\nцель — 3\n\nНарисуй квадратики или запиши числа:\nнужно: □ □ □ □\nхочу: □ □ □ □ □\nполезно: □ □ □ □ □ □\nцель: □ □ □\n\nОтветь:\n1. Каких карточек больше всего?\n2. Сколько всего карточек?\n3. На сколько «полезно» больше, чем «цель»?',
      ruPrimaryText: 'Нарисуй мини-график и реши 3 задачи.',
      enHelpText: 'Draw the mini graph and answer 3 questions.',
      answer: '1) Полезно. 2) 4 + 5 + 6 + 3 = 18. 3) 6 − 3 = 3.' },
    { id: 'spelling-choice-light', type: 'text', title: 'Задание 8 — Правописание / Spelling',
      prompt: 'Напиши:\n\nвыбор\nцена\nцель\nриск\nвывод\n\nВставь буквы:\n\nвыб_р\nц_на\nце_ь\nр_ск\nвыв_д',
      ruPrimaryText: 'Напиши 5 слов и вставь пропущенные буквы.',
      enHelpText: 'Write 5 words and fill in the missing letters.',
      answer: 'выбор, цена, цель, риск, вывод.' },
    { id: 'creative-choice-stamp', type: 'text', title: 'Задание 9 — Штамп огонька выбора / Choice Light Stamp',
      prompt: 'Нарисуй штамп Огонька выбора в quest passport.\n\nВ штампе должны быть:\n1. маленький огонёк\n2. знак цели\n3. две корзины\n4. фраза:\n\nЯ выбираю с пользой.',
      ruPrimaryText: 'Нарисуй штамп Огонька выбора с 4 элементами.',
      enHelpText: 'Draw the Light of Choice stamp with 4 elements.',
      answer: 'Open-ended. Accept if stamp includes light, goal, baskets and the phrase attempt.' },
    { id: 'speech-choice-light', type: 'text', title: 'Задание 10 — Объясни родителю / Explain to Parent',
      prompt: 'Скажи родителю по-русски:\n\nДеньги помогают выбирать.\nПольза создаёт ценность.\nЯ могу копить на цель.\nЯ не кладу всё в одну корзину.',
      ruPrimaryText: 'Скажи родителю минимум 3 идеи выбора по-русски.',
      enHelpText: 'Tell parent at least 3 of the 4 choice ideas in Russian.',
      answer: 'Accept if Anita says at least 3 of the 4 ideas with support.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова огонька выбора.',
    '2. Прочитай 5 фраз.',
    '3. Разложи 12 карточек выбора устно или в тетради.',
    '4. Реши 3 math-задачи.',
    '5. Нарисуй мини-график.',
    '6. Нарисуй штамп Огонька выбора.',
    '7. Объясни родителю главный вывод.'
  ],
  printWorksheet: {
    title: 'Огонёк выбора: деньги, ценность и цель / Light of Choice',
    subtitle: 'Неделя 10 · День 1 / Week 10 · Day 1 · Quest Passport',
    pages: [
      { title: 'Quest Passport: Огонёк выбора / Light of Choice',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Миссия: Нимни открывает первую дверь финального квеста. Собери Огонёк выбора.' },
          { type: 'text', text: 'Задание 1 — Слова огонька выбора. Прочитай и обведи:' },
          { type: 'list', items: [
            'выбор / choice',
            'цена / price',
            'польза / usefulness',
            'цель / goal',
            'копилка / savings jar',
            'остаток / remaining amount',
            'риск / risk',
            'корзина / basket',
            'огонёк / light',
            'вывод / conclusion'
          ] },
          { type: 'text', text: 'Задание 2 — Фразы огонька. Поставь галочку после чтения:' },
          { type: 'list', items: [
            '□ Деньги помогают выбирать.',
            '□ Польза создаёт ценность.',
            '□ Я могу копить на цель.',
            '□ Риск значит: результат не гарантирован.',
            '□ Я не кладу всё в одну корзину.'
          ] },
          { type: 'text', text: 'English help: Money helps people choose. Usefulness creates value. I can save for a goal. Risk means not guaranteed.' }
        ] },
      { title: 'Карточки и математика / Cards and Math',
        blocks: [
          { type: 'text', text: 'Задание 3 — Карточки выбора. Напиши категорию: Н = нужно, Х = хочу, П = полезно, Ц = цель.' },
          { type: 'list', items: [
            '1. вода ____',
            '2. тёплая куртка зимой ____',
            '3. наклейка ____',
            '4. книга для чтения ____',
            '5. маленькая игрушка ____',
            '6. копить на большую цель ____',
            '7. рюкзак для уроков ____',
            '8. конфета ____',
            '9. карандаш для рисования ____',
            '10. сохранить часть нимов ____',
            '11. реклама говорит «бери сразу» ____',
            '12. полезная идея, которая помогает человеку ____'
          ] },
          { type: 'text', text: 'Задание 4 — Ворота выбора:' },
          { type: 'list', items: [
            'карта 18 + компас 14 = ______',
            '72 − ______ = ______',
            'фонарик 22 + тетрадь 9 = ______',
            'карта + компас + тетрадь = ______',
            '72 − ______ = ______',
            'Останется хотя бы 25? да / нет'
          ] },
          { type: 'text', text: 'Задание 5 — Путь к цели:' },
          { type: 'list', items: [
            '4 миссии × 8 нимов = ______',
            '36 + ______ = ______',
            '96 − ______ = ______',
            '28 ÷ 4 = ______'
          ] },
          { type: 'text', text: 'Задание 6 — Корзины риска:' },
          { type: 'list', items: [
            '24 ÷ 3 = ______ в каждой корзине.',
            'Корзина 1: 8 + 2 = ______',
            'Корзина 2: 8 + 0 = ______',
            'Корзина 3: 8 + 4 = ______',
            'Всего: ______ + ______ + ______ = ______'
          ] }
        ] },
      { title: 'График, штамп и защита / Graph, Stamp and Defense',
        blocks: [
          { type: 'text', text: 'Задание 7 — Мини-график выбора:' },
          { type: 'list', items: [
            'нужно — 4: □ □ □ □',
            'хочу — 5: □ □ □ □ □',
            'полезно — 6: □ □ □ □ □ □',
            'цель — 3: □ □ □'
          ] },
          { type: 'list', items: [
            'Больше всего: ____________________',
            'Всего карточек: ______',
            'Полезно больше цели на: ______'
          ] },
          { type: 'text', text: 'Задание 8 — Правописание. Напиши и вставь буквы:' },
          { type: 'list', items: ['выбор   цена   цель   риск   вывод', 'выб_р   ц_на   це_ь   р_ск   выв_д'] },
          { type: 'text', text: 'Задание 9 — Штамп огонька выбора. Нарисуй:' },
          { type: 'list', items: [
            '□ огонёк',
            '□ знак цели',
            '□ две корзины',
            '□ фраза «Я выбираю с пользой.»'
          ] },
          { type: 'text', text: 'Задание 10 — Объясни родителю. Поставь галочку:' },
          { type: 'list', items: [
            '□ Деньги помогают выбирать.',
            '□ Польза создаёт ценность.',
            '□ Я могу копить на цель.',
            '□ Я не кладу всё в одну корзину.'
          ] },
          { type: 'text', text: 'Parent Check: □ Прочитала слова  □ Прочитала фразы  □ Разложила карточки  □ Решила math-задачи  □ Сделала штамп огонька  □ Объяснила родителю.' },
          { type: 'text', text: 'Notebook Mode — если нет принтера, сделай эти задания в тетради.' }
        ] }
    ]
  },
  parentGuide: {
    goal: 'Анита повторяет деньги, выбор, пользу, цель, риск и идею «не всё в одну корзину» через лёгкий финальный квест.',
    mathGoal: 'Сложение, вычитание, умножение, деление, остаток, график и многошаговые задачи в учебной симуляции.',
    russianGoal: 'Прочитать слова выбор, цена, польза, цель, копилка, остаток, риск, корзина, огонёк, вывод.',
    readingWritingGoal: 'Прочитать 5 фраз, написать 5 слов, подписать quest stamp.',
    practicalGoal: 'Разложить карточки выбора и объяснить, почему польза важнее импульса.',
    parentTheoryCard: {
      title: 'Как провести финальный квест без давления',
      purpose: 'Помочь родителю провести повторение как игру, а не экзамен.',
      keyMessage: 'Week 10 — это сбор огоньков знаний. Ребёнку важно почувствовать: «Я помню, понимаю и могу объяснить.»',
      parentScript: [
        '«Сегодня не контрольная. Сегодня ты собираешь первый огонёк.»',
        '«Мы вспоминаем Week 1: выбор, пользу, цель и риск.»',
        '«Если трудно — я помогу, но ты попробуешь объяснить по-русски.»',
        '«Главное — не идеальность, а понимание.»'
      ],
      practiceSteps: [
        'Сначала прочитайте слова.',
        'Потом разложите карточки.',
        'Решите math-задачи.',
        'Нарисуйте штамп.',
        'Попросите Аниту объяснить 2–4 идеи.'
      ],
      doNotSay: [
        'Не говорить «экзамен».',
        'Не сравнивать с Максимом.',
        'Не говорить, что нимы — реальные деньги.',
        'Не требовать идеальной скорости чтения.'
      ],
      paperOnlyNotes: [
        'Quest passport можно делать в тетради.',
        'Штамп может быть простым рисунком.',
        'Реальных денег и покупок нет.'
      ]
    },
    whatThisLessonTeaches: 'Анита собирает Огонёк выбора и повторяет ключевые идеи Week 1.',
    keyMessage: 'Деньги — это инструмент выбора. Польза и цель помогают выбирать умнее.',
    howToExplain: 'Скажите: «Когда мы выбираем, мы не просто смотрим на цену. Мы думаем: это нужно, полезно, цель или просто хочу?»',
    exampleDialogue:
      'Parent: Что важнее — красивая реклама или польза?\nChild: Польза.\nParent: Что значит риск?\nChild: Результат не гарантирован.\nParent: Почему не всё в одну корзину?\nChild: Так безопаснее.',
    readingSupport: 'Слова «остаток», «корзина», «вывод» можно читать по частям.',
    russianSpeechGoal: 'Анита говорит минимум 3 идеи выбора по-русски.',
    mathAnswerKey:
      'math-choice-gate: 1) 32. 2) 40. 3) 31. 4) Да, останется 31.\nmath-saving-light: 1) 32. 2) 68. 3) 28. 4) 7.\nmath-basket-risk: 1) 8. 2) 10. 3) 8. 4) 12. 5) 30.\nquest-memory-graph: 1) Полезно. 2) 18. 3) 3.',
    spellingAnswerKey: 'выбор\nцена\nцель\nриск\nвывод',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка чтения.' },
      { taskId: 'reading-sentences', answer: 'Попытка чтения.' },
      { taskId: 'choice-card-sort', answer: 'Нужно: 1,2; Хочу: 3,5,8,11; Полезно: 4,7,9,12; Цель: 6,10.' },
      { taskId: 'math-choice-gate', answer: '32; 40; 31; да, 31.' },
      { taskId: 'math-saving-light', answer: '32; 68; 28; 7.' },
      { taskId: 'math-basket-risk', answer: '8; 10; 8; 12; 30.' },
      { taskId: 'quest-memory-graph', answer: 'полезно; 18; 3.' },
      { taskId: 'spelling-choice-light', answer: 'выбор, цена, цель, риск, вывод.' },
      { taskId: 'creative-choice-stamp', answer: 'stamp with light, goal, baskets and phrase.' },
      { taskId: 'speech-choice-light', answer: 'at least 3 ideas spoken.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита разложила карточки.',
      'Анита решила math-задачи.',
      'Анита сделала штамп.',
      'Анита объяснила родителю 2–4 идеи.'
    ],
    spellingCheck: 'Проверить выбор, цена, цель, риск, вывод.',
    readingCheck: 'Засчитывать попытку русского чтения. Помогать мягко.',
    practicalCheck: 'Анита должна отличать need/want/useful/goal хотя бы на большинстве карточек.',
    drawingCriteria: 'Штамп содержит огонёк, цель, корзины и фразу.',
    commonMistakes: [
      '«Если хочу, значит надо взять.» Правильно: «Можно хотеть, но цель и польза помогают выбрать.»',
      '«Риск — это всегда плохо.» Правильно: «Риск — это неопределённость. Его нужно понимать.»',
      '«Нимы — настоящие деньги.» Правильно: «Нимы — призовые токены курса.»'
    ],
    discussionPrompts: [
      'Что такое польза?',
      'Почему цель помогает выбирать?',
      'Почему не всё в одну корзину?'
    ],
    ifEasy: 'Попросить Аниту придумать свой пример choice-card и категорию.',
    ifDifficult: 'Использовать только 6 карточек и считать вместе.',
    rewardGuidance: 'Базовая награда — 3 нима. Бонус за чтение или ясное объяснение.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не обсуждать реальные покупки, реальные деньги, банковские данные или конвертацию нимов.',
    safetyNotes: 'Все задания — учебная симуляция. Никаких реальных покупок или финансовых действий.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима',
    bonuses: [
      { id: 'reading-attempt', label: 'Бонус за хорошую попытку русского чтения', amount: 1 },
      { id: 'clear-choice-explain', label: 'Бонус за ясное объяснение выбора', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'choice-card-sort', 'math-choice-gate', 'math-saving-light', 'math-basket-risk', 'quest-memory-graph', 'spelling-choice-light', 'creative-choice-stamp', 'speech-choice-light'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-10-day-2'
};

export default day1;
